import { Observable, interval, pipe } from "rxjs";
import { map, distinct, filter, first } from "rxjs/operators";

export const onDomLoaded = () => {
    return interval(100)
        .pipe(
            map((x) => document.readyState),
            distinct((x) => x),
            filter((x) => x === "complete"),
            map((x) => true),
            first()
        )
        .toPromise();
};

export const getExtensionFromFileName = (filename) => {
    filename = filename || "";
    return filename.includes(".") ? filename.split(".").pop() : "file";
};

export const onAppLoaded = () => {
    return interval(20)
        .pipe(
            map((x) => document.getElementById("app")),
            filter((x) => x != null),
            first()
        )
        .toPromise();
};



// WEBPACK FOOTER //
// ./src/utils/utils.js